import api from './api';
import { Timesheet } from './timesheets';
import { Expense } from './expenses';

export interface TimesheetWithUser extends Timesheet {
  userName: string;
  userEmail: string;
}

export interface ExpenseWithUser extends Expense {
  userName: string;
  userEmail: string;
}

export interface ApprovalsData {
  timesheets: TimesheetWithUser[];
  expenses: ExpenseWithUser[];
}

export const approvalsApi = {
  getAll: async (): Promise<ApprovalsData> => {
    const response = await api.get('/approvals');
    return response.data.data;
  },

  approveTimesheet: async (id: string): Promise<Timesheet> => {
    const response = await api.put(`/approvals/${id}/approve`);
    return response.data.data;
  },

  rejectTimesheet: async (id: string, reason?: string): Promise<Timesheet> => {
    const response = await api.put(`/approvals/${id}/reject`, { reason });
    return response.data.data;
  },

  approveExpense: async (id: string): Promise<Expense> => {
    const response = await api.put(`/approvals/expenses/${id}/approve`);
    return response.data.data;
  },

  rejectExpense: async (id: string, reason?: string): Promise<Expense> => {
    const response = await api.put(`/approvals/expenses/${id}/reject`, { reason });
    return response.data.data;
  },
};





